/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */
import fetch from 'services/fetch.service';
import urlPath from 'services/url-path';
import {auth} from 'services/auth.service';
import userStore from 'services/user-store';

export interface IPlaylist {
  info: {
    bitrate?: number;
    height?: number;
    framesPerSecond?: number;
  };
  isEncrypted: boolean;
  isPrimary: boolean;
  isProtected: boolean;
  isVariant: boolean;
  name: string;
  type: string;
  uri: string;
}

export const fetchPlaylist = async(streamId: string): Promise<IPlaylist[]> => {
  const headers = new Headers();
  const [applicationId, secret] = await Promise.all([
    userStore.get(auth.applicationId),
    userStore.get(auth.secret)
  ]);

  headers.set('Authorization', `Basic ${await userStore.get(auth.token)}`);

  const response = await fetch.put({ // NOTE: this request requires credentials to be passed. Does not work with token in headers
    url: urlPath.fetchPlaylist,
    headers,
    data: {
      applicationId,
      secret: atob(secret),
      streamId
    }
  });

  return response.data.playlists;
};